<template>
  <div>
    <b-form-group label="Grupo de Usuários">
      <validation-provider
        #default="{ errors }"
        :rules="required"
        name="Grupo de Usuários"
      >
        <v-select
          ref="grupoSelect"
          v-model="valueInner"
          :options="grupoUsuarios"
          label="nome"
          :clearable="false"
          :disabled="disabled"
          :multiple="multiple"
          @close="onTouch"
          @open="carregarGrupos"
          @search-change="carregarGruposFiltrados"
          @input="enviarParaPai"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

  </div>
</template>

<script>
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import api from '@/app-modulo/comuns/grupo-usuario/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'GrupoPermissoesSelect',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    // value can be an Object (single) or an Array (multiple)
    value: {
      type: [Object, Array],
      default: null,
    },
    filtrarPorTipo: {
      type: Boolean,
      default: false,
    },
    tipoExterno: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      valueAttr: null,
      foiAcessado: false,
      grupoUsuarios: [],
      grupoUsuariosOriginal: [],
      primeiroAcesso: true,
      nomeGrupo: '',
    }
  },
  computed: {
    valueInner: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
  },
  methods: {
    carregarGrupos() {
      // Load groups either from getAll or getPorTipo depending on filtrarPorTipo
      let loader
      if (!this.filtrarPorTipo) {
        if (this.primeiroAcesso) loader = api.getAll(1, 1000, {})
        else loader = Promise.resolve({ data: { queryable: this.grupoUsuariosOriginal } })
      } else {
        loader = api.getPorTipo(this.tipoExterno)
      }

      loader.then(payload => {
        // API may return either an array directly or wrapped in data.queryable
        let items = []
        if (Array.isArray(payload)) items = payload
        else if (payload && Array.isArray(payload.data)) items = payload.data
        else if (payload && payload.data && Array.isArray(payload.data.queryable)) items = payload.data.queryable
        else if (payload && Array.isArray(payload.queryable)) items = payload.queryable

        // If items found, set both original and current lists
        this.grupoUsuariosOriginal = items || []
        this.grupoUsuarios = [...this.grupoUsuariosOriginal]
        this.primeiroAcesso = false
      }).catch(err => {
        this.$errorFormated(err && err.response ? err.response : err)
        throw err
      })
    },
    carregarGruposFiltrados(nomeGrupo) {
      // Filtra a partir da lista original para avoid progressive narrowing
      if (!nomeGrupo) {
        this.grupoUsuarios = [...this.grupoUsuariosOriginal]
        return
      }

      const term = String(nomeGrupo).toLowerCase()
      this.grupoUsuarios = (this.grupoUsuariosOriginal || []).filter(fil => (fil.nome || '').toLowerCase().includes(term))
    },
    propagarParaFilho() {
      this.$refs.grupoSelect.focus()
    },
    enviarParaPai() {
      const payload = !this.valueInner ? null : this.valueInner
      this.$emit('select', payload)
      this.$emit('input', payload)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      this.valueInner = []
    },
  },
}
</script>
